export const GAME_SYNC_SAVEPOINT = 'GAME_SYNC_SAVEPOINT'
export const LOADED = 'SAVEPOINT_LOADED'
export const SAVE_FINISH_ERROR = 'SAVEPOINT_SAVE_FINISH_ERROR'
export const SAVE_FINISH_OK = 'SAVEPOINT_SAVE_FINISH_OK'
export const SAVE_START = 'SAVEPOINT_SAVE_START'
export const USERINFO_SYNC_SAVEPOINT = 'USERINFO_SYNC_SAVEPOINT'
export const UPDATE_OBJECT_STATUS = 'SAVEPOINT_UPDATE_OBJECT_STATUS'

export const finishSaveOk = (newSavePoint) => {
  return { type: SAVE_FINISH_OK, data: newSavePoint }
}

export const finishSaveError = (error) => {
  return { type: SAVE_FINISH_ERROR, data: error }
}

export const startSave = () => {
  return { type: SAVE_START }
}

export const syncWithGame = (game) => {
  return { type: GAME_SYNC_SAVEPOINT, data: game }
}

export const syncWithUserInfo = (userInfo) => {
  return { type: USERINFO_SYNC_SAVEPOINT, data: userInfo }
}

export const updateObjectStatus = (item) => {
  return { type: UPDATE_OBJECT_STATUS, data: item }
}
